import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import QuadcoApp from './QuadcoApp';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import { store, history} from './store';



const theRoot = document.getElementById('root');

ReactDOM.render(
    <Provider store={store}>
        <QuadcoApp />
    </Provider>
, theRoot);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
